<template>
    <div class="plano_modal" v-if="visible">
        <b-card>
            <label> <h3>Generate Hooks</h3> </label>
            <b-container fluid>
                <b-row>
                    <b-col sm="4"> <label>Blister Width:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="blisterWidth"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Blister Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="blisterHeight"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Left:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="left"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Right:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="right"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Top:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="top"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Bottom:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="bottom"></NumberInput> </b-col>
                </b-row>
            </b-container>
            <b-button-toolbar>
                <b-button style="margin:5px;" variant="primary" @click="validate();">Ok</b-button>
                <b-button style="margin:5px;" @click="cancel();">Cancel</b-button>
            </b-button-toolbar>
        </b-card>
    </div>
</template>

<script>
import NumberInput from "../components/number-input";

let generateHooksWidget;
window.generateHooks = function generateHooks(data, onValidate, onCancel) {
    generateHooksWidget.left = -data.width / 2 + 5 + 30 / 2;
    generateHooksWidget.right = data.width / 2 - 5 - 30 / 2;
    generateHooksWidget.top = -data.height / 2 + 5 + 60 / 2;
    generateHooksWidget.bottom = data.height / 2 - 5 - 60 / 2;
    generateHooksWidget.visible = true;
    generateHooksWidget.onValidate = onValidate;
    generateHooksWidget.onCancel = onCancel;
};
export default {
    components: { NumberInput },
    data() {
        return {
            blisterWidth: 40,
            blisterHeight: 60,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    created() {
        generateHooksWidget = this;
    },
    methods: {
        validate() {
            this.onValidate({
                blisterWidth: parseFloat(this.blisterWidth),
                blisterHeight: parseFloat(this.blisterHeight),
                left: parseFloat(this.left),
                right: parseFloat(this.right),
                top: parseFloat(this.top),
                bottom: parseFloat(this.bottom)
            });
            this.visible = false;
        },
        cancel() {
            this.onCancel();
            this.visible = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// generate_hooks.vue?73bc9000